import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { Permission } from '../../types/Auth';
import { NotFound, PrivateRoute } from '../public';

import LogsListContainer from './LogsListContainer';

const LogsView: React.FC = (): React.ReactElement => {
    const routeMatch = useRouteMatch();
    return (
        <Switch>
            <PrivateRoute
                exact
                path={routeMatch.path}
                comp={LogsListContainer}
                perm={Permission.JOB_LIST_SECTION_VIEW}
            />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default LogsView;
